import { AlertcLinear } from './alertclinear.model';
import { AlertcPoint } from './alertcpoint.model';
import { VildData } from './vilddata.model';

export class Alertc {
  public vildLocation: VildData;
  public offsetDistance: number;
  public latitude: number;
  public longitude: number;
  public carriageway: string; // CarriagewayType

  public getAlertc(alertcPoint: AlertcPoint): Alertc {
    const alertc = new Alertc();
    if (alertcPoint.vildLocation) {
      alertc.vildLocation = alertcPoint.vildLocation;
    } else {
      alertc.vildLocation = new VildData();
    }
    alertc.offsetDistance = alertcPoint.offsetDistance;
    alertc.latitude = alertcPoint.displayLatitude;
    alertc.longitude = alertcPoint.displayLongitude;
    alertc.carriageway = alertcPoint.carriageway;
    return alertc;
  }

  public getPrimaryAlertc(alertcLinear: AlertcLinear): Alertc {
    const primaryAlertc = new Alertc();

    if (alertcLinear.primaryVildLocation) {
      primaryAlertc.vildLocation = alertcLinear.primaryVildLocation;
    } else {
      primaryAlertc.vildLocation = new VildData();
    }
    primaryAlertc.offsetDistance = alertcLinear.primaryOffsetDistance;
    primaryAlertc.latitude = alertcLinear.endLatitude;
    primaryAlertc.longitude = alertcLinear.endLongitude;
    primaryAlertc.carriageway = alertcLinear.carriagewayEndpoint;

    return primaryAlertc;
  }

  public getSecondaryAlertc(alertcLinear: AlertcLinear): Alertc {
    const secondaryAlertc = new Alertc();

    if (alertcLinear.secondaryVildLocation) {
      secondaryAlertc.vildLocation = alertcLinear.secondaryVildLocation;
    } else {
      secondaryAlertc.vildLocation = new VildData();
    }
    secondaryAlertc.offsetDistance = alertcLinear.secondaryOffsetDistance;
    secondaryAlertc.latitude = alertcLinear.startLatitude;
    secondaryAlertc.longitude = alertcLinear.startLongitude;
    secondaryAlertc.carriageway = alertcLinear.carriagewayStartpoint;

    return secondaryAlertc;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/alertc.model.ts